export default class RemoveTimesheetsFromInvoiceRequest {
  public timesheetIds: string[] = [];
}
